import dayjs from 'dayjs';

import { apiClient } from 'src/services/api';
import type { IShowing } from 'src/api/landlord-showings-api';

const TWENTY_ONE_DAYS_AGO = dayjs().startOf('day').subtract(21, 'days').toISOString().replace('Z', '');

export const usePaginatedShowings = async (cursor?: string) => {

    const _searchParams = new URLSearchParams();
    _searchParams.append('whole_team', 'true');
    if (cursor) {
        const startsBeforeFormatted = dayjs.utc(cursor).format('YYYY-MM-DDTHH:mm:ss');
        _searchParams.append('starts_before', startsBeforeFormatted);
    }

    const data = await apiClient('api/landlord/showings', {
        searchParams: _searchParams
    }).json<{ showings: IShowing[]; has_more?: boolean; oldest_showing_start_time?: string }>();

    const filteredShowings = data.showings.filter(showing =>
        showing.start_time >= TWENTY_ONE_DAYS_AGO
    );

    const oldestStartTime = data.oldest_showing_start_time ??
            (data.showings.length > 0 ? data.showings.reduce((oldest, showing) =>
                showing.start_time < oldest ? showing.start_time : oldest,
            data.showings[0].start_time
            ) : undefined);

    const shouldContinuePagination = !!(data.has_more ?? false) && !!oldestStartTime && oldestStartTime >= TWENTY_ONE_DAYS_AGO;

    return {
        showings: filteredShowings,
        hasMore: shouldContinuePagination,
        nextCursor: shouldContinuePagination ? oldestStartTime : undefined,
    };
};